export default {
    submitSearchQuery: "Potvrdi unos pretrage",
    resetSearchQuery: "Resetuj unos pretrage",
    cantFindMatches: "Ne možemo da pronađemo nijedan rezultat za",
    seeAllProducts: "Pogledaj sve proizvode",
}
